"use client";

import { useSyncExternalStore } from "react";

/**
 * Misst die gerenderte Hoehe von <header id="site-header"> (components/site-header.tsx) -
 * fuer sticky Elemente darunter (Fortschrittsbalken, Inhaltsverzeichnis), die sonst
 * hinter dem sticky Header verschwinden wuerden. Dynamisch statt hartcodiert, damit eine
 * kuenftige Header-Aenderung nicht still einen falschen Offset hinterlaesst.
 *
 * useSyncExternalStore statt useState+useEffect: der Header ist ein externer DOM-/
 * ResizeObserver-Zustand, gleiches Muster wie lib/use-narrow-viewport.ts (matchMedia dort).
 * ResizeObserver feuert bei .observe() sofort einmal mit der aktuellen Groesse - deckt
 * Erstmessung und spaetere Groessenaenderungen mit demselben Mechanismus ab.
 */
export function useHeaderOffset(): number {
  function subscribe(callback: () => void): () => void {
    const header = document.getElementById("site-header");
    if (!header) return () => {};
    const observer = new ResizeObserver(callback);
    observer.observe(header);
    return () => observer.disconnect();
  }

  function getSnapshot(): number {
    return document.getElementById("site-header")?.getBoundingClientRect().height ?? 0;
  }

  function getServerSnapshot(): number {
    return 0;
  }

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
